import { useAppLocalization } from "../../../../../localization/components/AppLocalizationProvider"
import { LocalizedStrict } from "../../../../../localization/components/AppLocalized"
import { StandardTabs } from "../../../../../../shared/components/tabs/StandardTabs"
import { PageHeader } from "../../../../../../shared/components/pageHeader/PageHeader"
import { Page } from "../../../../../../shared/components/pageHeader/PageHeaderApi"
import { BillReceiversTab } from "../components/BillReceiversTab"

export function UserSettings() {
    const { l10n } = useAppLocalization()

    const tabs = [
        {
            label: l10n.getString("user-settings-tab-bill-receivers"),
            component: <BillReceiversTab />,
        },
    ]

    return (
        <>
            <LocalizedStrict id="user-settings-page-title" attrs={{ title: true }}>
                <PageHeader page={Page.USER_SETTINGS} title="Settings" />
            </LocalizedStrict>
            <StandardTabs tabs={tabs} />
        </>
    )
}
